export default function isNewPricingPromoBannersFlagOn(
  newPricingPromoBannersFlag
) {
  // This is a multivariate JSON flag. It's considered "on" when the served
  // variation is different than the empty object, which corresponds to "off".
  return Object.keys(newPricingPromoBannersFlag || {}).length > 0;
}
